var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.$route.name === 'projectTextTemplatesEditor')?_c('Editor'):(_vm.$route.name === 'projectTextTemplatesCreate')?_c('Create'):(_vm.$route.name === 'projectTextTemplatesDetails')?_c('Details'):_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }